import AuthenticatedIframe from '../AuthenticatedIframe';

interface Props {
    assetLocationId: string;
    page: 'telemetry' | 'maintenance' | 'sla-asset-report';
}

const AssetConditionMonitoringIframe = ({ assetLocationId, page }: Props) => {
    const src = `${process.env.REACT_APP_BUSCH_IOT_URL}/iot-asset/${assetLocationId}/${page}`;
    return <AuthenticatedIframe src={src} title={page} />;
};

export default AssetConditionMonitoringIframe;
